import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon4am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99997 12.7499C5.37663 12.7499 3.25 10.6233 3.25 7.99997C3.25 5.37663 5.37663 3.25 7.99997 3.25C10.6233 3.25 12.7499 5.37663 12.7499 7.99997C12.7499 10.6233 10.6233 12.7499 7.99997 12.7499ZM7.99997 13.9999C4.68628 13.9999 2 11.3137 2 7.99997C2 4.68628 4.68628 2 7.99997 2C11.3137 2 13.9999 4.68628 13.9999 7.99997C13.9999 11.3137 11.3137 13.9999 7.99997 13.9999Z"
        fill="currentColor"
      />
      <path
        d="M4.76523 12.1348C3.23803 12.1348 2 10.2836 2 7.99997C2 5.71638 3.23803 3.86523 4.76523 3.86523C6.29242 3.86523 7.53046 5.71645 7.53046 8.00003C7.53046 10.2836 6.29242 12.1348 4.76523 12.1348Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon4am;
